import { type Dictionary } from '@ngrx/entity';

import { type PropsOf } from '@blaze-runtime/engine-domain';
import { type FormListErrors, type FormValidationErrors } from '@blaze-shared/elements-domain';

/**
 * Validates a form list against the row count its author allowed. The result is reported
 * as the list's own row entry, keyed by the empty column name, because the limits belong
 * to the list rather than to any of its columns.
 */
export function validateRowLimits(
  rows: Record<string, any>[],
  props: PropsOf<'editableList'> | undefined,
): FormListErrors {
  const errors: Dictionary<FormValidationErrors> = {};
  const options = props?.content?.options;
  const rowCount = rows.filter((row) => !row._isDeleted).length;

  // why: the limit travels inside the error so the message can quote it, even though the
  // shared FormValidationErrors type still declares every rule as a boolean flag
  if (options?.hasMinRows && options.minRows !== undefined && rowCount < options.minRows) {
    errors[''] = { minRows: options.minRows as unknown as boolean };
  }
  if (options?.hasMaxRows && options.maxRows !== undefined && rowCount > options.maxRows) {
    errors[''] = { maxRows: options.maxRows as unknown as boolean };
  }

  return {
    errors,
    valid: !Object.keys(errors).length,
    displayIndex: 0,
  };
}
